var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.625,
    height: 17,
    viewBox: "0 0 10.625 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#4d4f5c;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1343.869,4972.229h-9.562a.531.531,0,0,0-.532.531v10.625a.53.53,0,0,0,.137.355l4.781,5.313a.529.529,0,0,0,.395.176.529.529,0,0,0,.395-.176l4.782-5.312a.534.534,0,0,0,.136-.355V4972.76A.531.531,0,0,0-1343.869,4972.229Z",
    transform: "translate(1353.963 -4972.229)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbBlack);
export default __webpack_public_path__ + "static/media/thumb-black.89bbda417bb3e79b135fe0dc2cd617ed.svg";
export { ForwardRef as ReactComponent };